import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import {
  filterOptionsSelectedAction,
  filterDataAction,
  setFilterOptionsAction,
} from "../../redux/actions/index";
import {
  fetchFilterDataFromDb,
  getDefaultFilterSelect,
  mustRequired,
  userInputs,
} from "../services/FilterDataService";

import Swal from "sweetalert2";

import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';
import { Button } from "@mui/material";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import IconButton from "@mui/material/IconButton";

//Css style
const Table = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  width: "100%",
};

const IconStyleDark = {
  color: "white",
  marginLeft: "0.25rem",
  marginRight: "0.25rem",
};

const AutoFillDark = {
  "-webkit-box-shadow": "0 0 0 30px #1F2121 inset !important",
  "-webkit-text-fill-color": "white !important"
};

const AutoFillLight = {
  "-webkit-box-shadow": "0 0 0 30px #E5E7E9 inset !important",
  "-webkit-text-fill-color": "black !important"
};

const HeaderDark = {
  display: "flex",
  color: "white",
  fontSize: "12px",
  alignItems: "center",
  maxWidth: "6.5rem",
  maxHeight: "1.5rem",
  fontWeight: "16px",
  marginLeft: "1rem",
};

const IconStyleLight = {
  color: "#17202A",
  marginLeft: "0.25rem",
  marginRight: "0.25rem",
};

const HeaderLight = {
  display: "flex",
  color: "#17202A",
  fontSize: "12px",
  alignItems: "center",
  maxWidth: "6.5rem",
  maxHeight: "1.5rem",
  fontWeight: "16px",
  marginLeft: "1rem",
};

const OpenIcon = {
  display: "flex",
  justifyContent: "flex-end",
  //color: "white",
  alignItems: "center",
  marginRight: "1.3rem",
  marginLeft: "1.3rem",
};

// const InputBox = {
//   border: "1px dashed grey",
//   borderRadius: "12px",
//   boxShadow: 1,
//   padding: "1rem",
// };

// const legendDark = {
//   color: "white",
//   fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri !important`,
// };
// const legendLight = {
//   color: "#17202A",
//   fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri !important`,
// };

const SeparatorDark = { backgroundColor: "white" };
const SeparatorLight = { backgroundColor: "#17202A" };

const gridRowSize = 6;

export function Filters(props) {
  //Get Filter Options Data
  //const filterOptionsData = props.metaData.filterOptions ? props.metaData.filterOptions : null ;

  let filterOptionsData = props.filterOptions;

  //this.state values
  const selectedFiltersFromStore = props.selectedMetaData.selectedFilters;

  //set default filters values - imp - item.key == getDefaultFilterSelect field name
  const defaultFiltersValues = props.defaultValues;
  if (defaultFiltersValues && defaultFiltersValues.length > 0){
    defaultFiltersValues.map((item) =>
    getDefaultFilterSelect[item.key] = item.value);
  }  

  const [filterSelectedData, setFilterSelectedData] = useState(
    getDefaultFilterSelect
  );    

  const [optionRegion, setOptionRegion] = useState([]);
  const [optionState, setOptionState] = useState([]);
  const [optionMake, setOptionMake] = useState([]);
  const [optionModel, setOptionModel] = useState([]);
  const [optionStyle, setOptionStyle] = useState([]);

  const [errorCashDown, setErrorCashDown] = useState(false);
  const [errorTradeAmt, setErrorTradeAmt] = useState(false);
  const [errorPaidOff, setErrorPaidOff] = useState(false);
  const [errorPayCap, setErrorPayCap] = useState(false);
  const [errorMileCap, setErrorMileCap] = useState(false);
  const [errorFinCap, setErrorFinCap] = useState(false);
  const [errorYearOld, setErrorYearOld] = useState(false);  
  const [errorZipCode, setErrorZipCode] = useState(false);
  const [errorStateTx, setErrorStateTx] = useState(false);
  const [errorDMV, setErrorDMV] = useState(false);
  const [errorIncome, setErrorIncome] = useState(false);
  const [errorFico, setErrorFico] = useState(false);

  const textBoxProps = {
    variant: props.lightMode ? "outlined" : "standard",
    inputProps: {
      style: { fontSize: "12px" },
      // type: "number",
      // inputMode: "numeric",
      // pattern: "[0-9]*",
      min: "0",
    },    
    // font size of input text
    InputLabelProps: { style: { fontSize: "12px" } }, // font size of input label        
    type: "text",
    size: "small",
    style: { width: "100%" },
    onInput: (e) => {
      //e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,12)
      e.target.value = e.target.value;
    },
  };

  const textBoxPropsFloat = {
    variant: props.lightMode ? "outlined" : "standard",
    inputProps: {
      style: { fontSize: "12px"},
      //type: "number",
      //inputmode: "decimal",
      //pattern: "[0-9].[0-9]*",
    },
    // font size of input text
    InputLabelProps: { style: { fontSize: "12px" } }, // font size of input label
    type: "text",
    size: "small",
    style: { width: "100%" },
    onInput: (e) => {
      // e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,12)
      e.target.value = e.target.value;
    },
  };

  const autoProps = {
    size: "small",
    //maxheight: "15rem",
    limitTags: 1,
    //ChipProps : {{disabled:true}},
    multiple: true,
    disableCloseOnSelect: true,
    filterSelectedOptions: true,
    style: { width: "100%" },
    getOptionLabel: (option) => (option && option.toString()) || "",
    renderOption: (props, option, { selected }) => (
      <li {...props} style={{ fontSize: "12px" }}>
        {option}
      </li>
    ),
  };

  const autoCompleteProps = {
    size: "small",
    variant: props.lightMode ? "outlined" : "standard",
    //inputProps: {style: {minWidth:"0"} }, // font size of input text
    InputLabelProps: { style: { fontSize: "12px", } }, // font size of input label    
  };

  const singleSelectProps = {
    size: "small",
    //maxheight: "15rem",
    getOptionLabel: (option) => option,
    renderOption: (props, option, { selected }) => (
      <li {...props} style={{ fontSize: "12px" }}>
        {option}
      </li>
    ),
    style: { width: "100%" },
  };

  let filterDataToStore = { filterData: [], isLoading: false };

  //ComponentDidMount
  useEffect(() => {
    if (filterOptionsData) {
      setOptionRegion(filterOptionsData.regions || []);
      setOptionState(filterOptionsData.states || []);
      setOptionMake(filterOptionsData.rawMakes || []);
      setOptionModel(filterOptionsData.rawModels || []);
      setOptionStyle(filterOptionsData.rawStyles || []);
    }
    if (selectedFiltersFromStore){      
      getFilterOptionDataFromProps(selectedFiltersFromStore);
      
      resetErrorMsg();
    }
    else{      
      getFilterOptionDataFromProps(getDefaultFilterSelect);
      //setFilterSelectedData(getDefaultFilterSelect);
    }

  }, [filterOptionsData, selectedFiltersFromStore]);

  const setDefaultOptionsData = () => {
    //set Region/State/Make/Model/Style to default values
    setOptionRegion((filterOptionsData && filterOptionsData.regions) || []);
    setOptionState((filterOptionsData && filterOptionsData.states) || []);
    setOptionMake((filterOptionsData && filterOptionsData.rawMakes) || []);
    setOptionModel((filterOptionsData && filterOptionsData.rawModels) || []);
    setOptionStyle((filterOptionsData && filterOptionsData.rawStyles) || []);
  };

  const setOptionsDataBasedOnSelection = (
    rawData,
    filterOptionName = "",
    isDelete = false,
    firstSelectedFilter = ""
  ) => {
    let region = [...new Set(rawData.map((data) => data.region))];
    region = region.sort();
    let state = [...new Set(rawData.map((data) => data.dealer_state))];
    state = state.sort();
    let make = [...new Set(rawData.map((data) => data.make))];
    make = make.sort();
    let model = [...new Set(rawData.map((data) => data.model))];
    model = model.sort();
    let style = [...new Set(rawData.map((data) => data.body_style))];
    style = style.sort();

    //filter changed from delete clip components or from history
    if (filterOptionName === "") {
      setOptionRegion(region);
      setOptionState(state);
      setOptionMake(make);
      setOptionModel(model);
      setOptionStyle(style);
    } else {
      if (isDelete) {
        setDefaultOptionsData();
        if (firstSelectedFilter !== "region") setOptionRegion(region);
        if (firstSelectedFilter !== "dealer_state") setOptionState(state);
        if (firstSelectedFilter !== "make") setOptionMake(make);
        if (firstSelectedFilter !== "model") setOptionModel(model);
        if (firstSelectedFilter !== "body_style") setOptionStyle(style);
      } else {
        if (filterOptionName !== "region") setOptionRegion(region);
        if (filterOptionName !== "dealer_state") setOptionState(state);
        if (filterOptionName !== "make") setOptionMake(make);
        if (filterOptionName !== "model") setOptionModel(model);
        if (filterOptionName !== "body_style") setOptionStyle(style);
      }
    }
  };

  const getRegionFilterOptions = (
    isSelected,
    rawData,
    filterSelected = filterSelectedData
  ) => {
    return [
      ...rawData,
      ...filterOptionsData.rawData.filter((data) =>
        filterSelected.region.includes(data["region"])
      ),
    ];
  };

  const getStateFilterOptions = (
    isSelected,
    rawData,
    filterSelected = filterSelectedData
  ) => {
    if (isSelected) {
      return [
        ...rawData,
        ...rawData.filter((data) =>
          filterSelected.state.includes(data["dealer_state"])
        ),
      ];
    } else {
      return [
        ...rawData,
        ...filterOptionsData.rawData.filter((data) =>
          filterSelected.state.includes(data["dealer_state"])
        ),
      ];
    }
  };

  const getMakeFilterOptions = (
    isSelected,
    rawData,
    filterSelected = filterSelectedData
  ) => {
    if (isSelected) {
      return [
        ...rawData,
        ...rawData.filter((data) => filterSelected.make.includes(data["make"])),
      ];
    } else {
      return [
        ...rawData,
        ...filterOptionsData.rawData.filter((data) =>
          filterSelected.make.includes(data["make"])
        ),
      ];
    }
  };

  const getModelFilterOptions = (
    isSelected,
    rawData,
    filterSelected = filterSelectedData
  ) => {
    if (isSelected) {
      return [
        ...rawData,
        ...rawData.filter((data) =>
          filterSelected.model.includes(data["model"])
        ),
      ];
    } else {
      return [
        ...rawData,
        ...filterOptionsData.rawData.filter((data) =>
          filterSelected.model.includes(data["model"])
        ),
      ];
    }
  };

  const getStyleFilterOptions = (
    isSelected,
    rawData,
    filterSelected = filterSelectedData
  ) => {
    if (isSelected) {
      return [
        ...rawData,
        ...rawData.filter((data) =>
          filterSelected.style.includes(data["body_style"])
        ),
      ];
    } else {
      return [
        ...rawData,
        ...filterOptionsData.rawData.filter((data) =>
          filterSelected.style.includes(data["body_style"])
        ),
      ];
    }
  };

  //when filters are coming from clip components or history page
  const getFilterOptionDataFromProps = (filterSelected) => {
    setFilterSelectedData(filterSelected);

    let rawData = [];
    let isSelected = false;
    let firstSelectedFilter = "";

    //region
    if (
      filterSelected &&
      filterSelected.region != null &&
      filterSelected.region.length > 0
    ) {
      rawData = getRegionFilterOptions(isSelected, rawData, filterSelected);
      isSelected = true;
      firstSelectedFilter = "region";
    }

    //state
    if (
      filterSelected &&
      filterSelected.state != null &&
      filterSelected.state.length > 0
    ) {
      rawData = getStateFilterOptions(isSelected, rawData, filterSelected);
      isSelected = true;
      if (firstSelectedFilter.length === 0) {
        firstSelectedFilter = "dealer_state";
      }
    }

    //make
    if (
      filterSelected &&
      filterSelected.make != null &&
      filterSelected.make.length > 0
    ) {
      rawData = getMakeFilterOptions(isSelected, rawData, filterSelected);
      isSelected = true;
      if (firstSelectedFilter.length === 0) {
        firstSelectedFilter = "make";
      }
    }

    //model
    if (
      filterSelected &&
      filterSelected.model != null &&
      filterSelected.model.length > 0
    ) {
      rawData = getModelFilterOptions(isSelected, rawData, filterSelected);
      isSelected = true;
      if (firstSelectedFilter.length === 0) {
        firstSelectedFilter = "model";
      }
    }

    //style
    if (
      filterSelected &&
      filterSelected.style != null &&
      filterSelected.style.length > 0
    ) {
      rawData = getStyleFilterOptions(isSelected, rawData, filterSelected);
      isSelected = true;
      if (firstSelectedFilter.length === 0) {
        firstSelectedFilter = "body_style";
      }
    }

    if (!isSelected) {
      setDefaultOptionsData();
    } else {
      setOptionsDataBasedOnSelection(rawData, firstSelectedFilter);
    }
  };

  //Get Region/State/Make/Model/Style based on any filters selected
  const getFilterOptionsData = (newValues, itemNameChanged) => {
    let rawData = [];
    let isSelected = false;
    let firstSelectedFilter = "";

    //Deleting previous selected values
    if (newValues.length === 0) {
      if (
        itemNameChanged !== "region" &&
        filterSelectedData &&
        filterSelectedData.region != null &&
        filterSelectedData.region.length > 0
      ) {
        rawData = getRegionFilterOptions(isSelected, rawData);
        isSelected = true;
        firstSelectedFilter = "region";
      }
      if (
        itemNameChanged !== "dealer_state" &&
        filterSelectedData &&
        filterSelectedData.state != null &&
        filterSelectedData.state.length > 0
      ) {
        rawData = getStateFilterOptions(isSelected, rawData);
        isSelected = true;
        if (firstSelectedFilter.length === 0) {
          firstSelectedFilter = "dealer_state";
        }
      }
      if (
        itemNameChanged !== "make" &&
        filterSelectedData &&
        filterSelectedData.make != null &&
        filterSelectedData.make.length > 0
      ) {
        rawData = getMakeFilterOptions(isSelected, rawData);
        isSelected = true;
        if (firstSelectedFilter.length === 0) {
          firstSelectedFilter = "make";
        }
      }
      if (
        itemNameChanged !== "model" &&
        filterSelectedData &&
        filterSelectedData.model != null &&
        filterSelectedData.model.length > 0
      ) {
        rawData = getModelFilterOptions(isSelected, rawData);
        isSelected = true;
        if (firstSelectedFilter.length === 0) {
          firstSelectedFilter = "model";
        }
      }
      if (
        itemNameChanged !== "body_style" &&
        filterSelectedData &&
        filterSelectedData.style != null &&
        filterSelectedData.style.length > 0
      ) {
        rawData = getStyleFilterOptions(isSelected, rawData);
        isSelected = true;
        if (firstSelectedFilter.length === 0) {
          firstSelectedFilter = "body_style";
        }
      }
    } else {
      rawData = [
        ...rawData,
        ...filterOptionsData.rawData.filter((data) =>
          newValues.includes(data[itemNameChanged])
        ),
      ];
      isSelected = true;
    }

    if (!isSelected) {
      setDefaultOptionsData();
    } else {
      //last parameter to say that this filters removed by users
      setOptionsDataBasedOnSelection(
        rawData,
        itemNameChanged,
        newValues.length === 0,
        firstSelectedFilter
      );
    }
  };

  // const checkForUserDetails = () => {
  //   console.log("user login", props.user);
  //   if (
  //     props.user.name.trim() === "" ||
  //     props.user.email.trim() === "" ||
  //     props.user.expiry === "" ||
  //     props.user.expiry
  //   ) {
  //     props.history.push("/login");
  //   }
  // };

  const resetErrorMsg = () =>{
    //set Error msg to false
    setErrorCashDown(false);
    setErrorTradeAmt(false);
    setErrorPaidOff(false);
    setErrorZipCode(false);
    setErrorStateTx(false);
    setErrorDMV(false);
    setErrorIncome(false);
    setErrorFico(false);
    setErrorYearOld(false);
    setErrorMileCap(false);
    setErrorFinCap(false);
    setErrorPayCap(false);
  };

  //Apply Button Event
  const onApply = (e) => {
    e.preventDefault();

    //checkForUserDetails();

    //Check Fico and Income selected
    let isSelected = true;
    mustRequired.map((key) => {
      if (!filterSelectedData[key] || filterSelectedData[key].length === 0) {
        if (key === "income") setErrorIncome(true);
        if (key === "fico") setErrorFico(true);

        isSelected = false;
      }
    });

    //check user inputs are numeric/entered
    let isNumValid = true;
    if (errorCashDown || errorTradeAmt || errorPaidOff || errorPayCap || errorMileCap||errorFinCap||errorYearOld||errorZipCode||errorStateTx||errorDMV)
    {
      isNumValid = false;
    }

    //Check User inputs entered
    let isNotEntered = false;
    filterSelectedData &&
      Object.keys(filterSelectedData)
        .filter((key) => userInputs.includes(key))
        .map((key) => {
          if (filterSelectedData[key].trim().length === 0) {
            if (key === "cashDown") {
              setErrorCashDown(true);
            }
            // else if (key === "tradeAmt")
            // {
            //   setErrorTradeAmt(true);
            // }
            // else if (key === "paidOffAmt")
            // {
            //   setErrorPaidOff(true);
            // }
            else if (key === "zipCode") {
              setErrorZipCode(true);
            } else if (key === "stateTax") {
              setErrorStateTx(true);
            } else if (key === "dmvFee") {
              setErrorDMV(true);
            }
            isNotEntered = true;
          }
        });

    if (!isSelected || isNotEntered || !isNumValid) return;

    /* if (!isSelected && isNotEntered)
    {
      //Alert Message
      Swal.fire({
        position: "center",
        icon: "error",
        title: `Please select Fico/Income and enter inputs`,
        showConfirmButton: false,
        timer: 1500,
              }); 
      return;
    }
    else if (!isSelected) 
      { 
        //Alert Message
        Swal.fire({
          position: "center",
          icon: "error",
          title: `Please select Fico/Income`,
          showConfirmButton: false,
          timer: 1500,
                 }); 
        return;
      }
    else if(isNotEntered)
    {
       //Alert Message
       Swal.fire({
        position: "center",
        icon: "error",
        title: `Please enter inputs`,        
        showConfirmButton: false,
        timer: 1500,
      });

      return;
    }*/

    //Get Reports from service and set isLoading = false
    const isFilterSelected = fetchFilterDataFromDb(
      filterSelectedData,
      props,
      filterDataToStore,
      filterOptionsData
    );

    props.history.push("/");

    if (!isFilterSelected) {
      //Alert Message
      Swal.fire({
        position: "center",
        icon: "error",
        title: `Please select any filters`,
        showConfirmButton: true,
        confirmButtonColor: "#1451B5",
      });
    }
  };

  //Reset Button
  const onReset = (e) => {
    e.preventDefault();

    //checkForUserDetails();

    //set filtersselected by users to null and save to store
    setFilterSelectedData(getDefaultFilterSelect);
    props.filterOptionsSelectedAction(null);

    //set Region/State/Make/Model/Style to default values
    setOptionRegion((filterOptionsData && filterOptionsData.regions) || []);
    setOptionState((filterOptionsData && filterOptionsData.states) || []);
    setOptionMake((filterOptionsData && filterOptionsData.rawMakes) || []);
    setOptionModel((filterOptionsData && filterOptionsData.rawModels) || []);
    setOptionStyle((filterOptionsData && filterOptionsData.rawStyles) || []);

    //set DataGrid data to null
    filterDataToStore.filterData = [];
    filterDataToStore.isLoading = false;
    props.filterDataAction(filterDataToStore);

    //set Error msg to false
    resetErrorMsg();
  };

  //Changed Event
  const onDmvFeeChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim());

    if (validCode) {
      setErrorDMV(false);
    } else {
      setErrorDMV(true);
    }

    setFilterSelectedData({ ...filterSelectedData, dmvFee: e.target.value });
  };

  const onStateTaxChanged = (e) => {
    const validStateTax =
      /(^[0-9][\.\d]*?$)$/.test(e.target.value.trim()) 
    if (validStateTax) {
      setErrorStateTx(false);
    } else {
      setErrorStateTx(true);
    }

    setFilterSelectedData({ ...filterSelectedData, stateTax: e.target.value });
  };

  const onZipCodeChanged = (e) => {
    const validZipCode =
      /(^[0-9]*$)$/.test(e.target.value.trim()) &&
      e.target.value.trim().length === 5;
    if (validZipCode) {
      setErrorZipCode(false);
    } else {
      setErrorZipCode(true);
    }
    setFilterSelectedData({ ...filterSelectedData, zipCode: e.target.value });
  };

  const onPaidOffAmtChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim());

    if (validCode || e.target.value.trim().length === 0) {setErrorPaidOff(false);}
    else {setErrorPaidOff(true);}
    
    setFilterSelectedData({
      ...filterSelectedData,
      paidOffAmt: e.target.value,
    });
  };
  const onTradeAmtChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim());

    if (validCode || e.target.value.trim().length === 0) {setErrorTradeAmt(false);}
    else{setErrorTradeAmt(true);}

    setFilterSelectedData({ ...filterSelectedData, tradeAmt: e.target.value });
  };
  const onCashDownChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim());
    if (validCode) {
      setErrorCashDown(false);
    } else {
      setErrorCashDown(true);
    }

    setFilterSelectedData({ ...filterSelectedData, cashDown: e.target.value });
  };
  const onPayCapChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim());
    if (validCode  || e.target.value.trim().length === 0) {
      setErrorPayCap(false);
    } else {
      setErrorPayCap(true);
    }

    setFilterSelectedData({ ...filterSelectedData, payCap: e.target.value });
  };
  const onFinanceCapChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim());
    if (validCode  || e.target.value.trim().length === 0) {
      setErrorFinCap(false);
    } else {
      setErrorFinCap(true);
    }

    setFilterSelectedData({
      ...filterSelectedData,
      financedCap: e.target.value,
    });
  };
  const onMileCapChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim());
    if (validCode  || e.target.value.trim().length === 0) {
      setErrorMileCap(false);
    } else {
      setErrorMileCap(true);
    }

    setFilterSelectedData({ ...filterSelectedData, mileCap: e.target.value });
  };
  const onYearOldChanged = (e) => {
    const validCode =
    /(^[0-9]*$)$/.test(e.target.value.trim())&&
    e.target.value.trim().length === 4;
    if (validCode  || e.target.value.trim().length === 0) {
      setErrorYearOld(false);
    } else {
      setErrorYearOld(true);
    }

    setFilterSelectedData({
      ...filterSelectedData,
      yearOldest: e.target.value,
    });
  };

  const onIncomeChanged = (e, newValue) => {
    if (newValue && newValue.length > 0) {
      setErrorIncome(false);
    } else {
      setErrorIncome(true);
    }

    setFilterSelectedData({ ...filterSelectedData, income: newValue });
  };

  const onFicoChanged = (e, newValue) => {
    if (newValue && newValue.length > 0) {
      setErrorFico(false);
    } else {
      setErrorFico(true);
    }

    setFilterSelectedData({ ...filterSelectedData, fico: newValue });
  };

  const onConditionChanged = (e, newValue) => {
    setFilterSelectedData({ ...filterSelectedData, condition: newValue });
  };

  const onStyleChanged = (e, newValue) => {
    setFilterSelectedData({ ...filterSelectedData, style: newValue });
    getFilterOptionsData(newValue, "body_style");
  };

  const onModelChanged = (e, newValue) => {
    setFilterSelectedData({ ...filterSelectedData, model: newValue });
    getFilterOptionsData(newValue, "model");
  };

  const onMakeChanged = (e, newValue) => {
    setFilterSelectedData({ ...filterSelectedData, make: newValue });
    getFilterOptionsData(newValue, "make");
  };

  const onStateChanged = (e, newValue) => {
    setFilterSelectedData({ ...filterSelectedData, state: newValue });
    getFilterOptionsData(newValue, "dealer_state");
  };

  const onRegionChanged = (e, newValue) => {
    setFilterSelectedData({ ...filterSelectedData, region: newValue });
    getFilterOptionsData(newValue, "region");
  };

  const retFilterComp = (
    /* change Content based on Drawer Open or closed */

    <Box sx={{ width: "100%",fontFamily:`CircularXXWeb, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif !important`,"& input:-internal-autofill-selected": props.lightMode ?AutoFillLight : AutoFillDark,
      "& input:-webkit-autofill":props.lightMode ?AutoFillLight:AutoFillDark
      }}>
      <Box>
        <Grid maxHeight="4rem" container style={Table} columnSpacing={0} rowSpacing={0}>
          {props.user &&
            props.user.name.trim().length > 0 &&
            (props.isDrawerOpen ? (
              <>
                <Grid item xs={gridRowSize}>
                  <h6 style={props.lightMode ? HeaderLight : HeaderDark}>
                    <FontAwesomeIcon
                      size="lg"
                      icon={faFilter}
                      style={props.lightMode ? IconStyleLight : IconStyleDark}
                    />
                    FILTERS
                  </h6>
                </Grid>
                <Grid item xs={gridRowSize}>
                  <h6 style={OpenIcon}>
                    <IconButton
                      //color="primary"
                      aria-label="Contract"
                      onClick={props.handleDrawer}
                    >
                      <ArrowCircleLeftIcon
                        //color="primary"   
                        fontSize="medium"
                        titleAccess="Contract"
                        style={{ color: "#1451B5" }}
                      />
                    </IconButton>
                  </h6>
                </Grid>
              </>
            ) : (
              <Grid item xs={gridRowSize}>
                <h6 style={OpenIcon}>
                  <IconButton
                    //color="primary"
                    aria-label="Expand"
                    onClick={props.handleDrawer}
                  >
                    <ArrowCircleRightIcon
                      //color="primary"
                      fontSize="medium"
                      titleAccess="Expand"
                      style={{ color: "#1451B5" }}
                    />
                  </IconButton>
                </h6>
              </Grid>
            ))}
        </Grid>
      </Box>
      <Divider style={props.lightMode ? SeparatorLight : SeparatorDark} />
      {props.isDrawerOpen && filterOptionsData && (
        <Box component="form" style={{ width: "100%", padding: "0.25rem" }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12}>
              <Box component="fieldset" border="none">
                {/*<legend style={props.lightMode ? legendLight : legendDark}>Filters</legend>*/}
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {/* render  Region */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete
                      id="Region"
                      {...autoProps}
                      options={optionRegion}
                      value={filterSelectedData.region || []}
                      onChange={onRegionChanged}                      
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Region"
                          {...autoCompleteProps}                           
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (<><InputAdornment position="start">
                              </InputAdornment>                              
                              {params.InputProps.startAdornment}</>),
                            }}                         
                        />
                      )}
                    />
                  </Grid>

                  {/* render  State */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete
                      id="State"
                      {...autoProps}
                      options={optionState}
                      //renderTags = {(tagValue, getTagProps) =>{}}
                      value={filterSelectedData.state || []}
                      onChange={onStateChanged}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="State"
                          {...autoCompleteProps}                          
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (<><InputAdornment position="start">
                              </InputAdornment>                              
                              {params.InputProps.startAdornment}</>),
                            }}  
                        />
                      )}
                    />
                  </Grid>

                  {/* render Make */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete
                      {...autoProps}
                      id="Make"
                      options={optionMake}
                      value={
                        (filterSelectedData && filterSelectedData.make) || []
                      }
                      onChange={onMakeChanged}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Make"
                          {...autoCompleteProps}                          
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (<><InputAdornment position="start">
                              </InputAdornment>                              
                              {params.InputProps.startAdornment}</>),
                            }}  
                        />
                      )}
                    />
                  </Grid>

                  {/* render Model */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete
                      id="Model"
                      options={optionModel}
                      {...autoProps}
                      value={
                        (filterSelectedData && filterSelectedData.model) || []
                      }
                      onChange={onModelChanged}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Model"
                          {...autoCompleteProps}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (<><InputAdornment position="start">
                              </InputAdornment>                              
                              {params.InputProps.startAdornment}</>),
                            }}  
                        />
                      )}
                    />
                  </Grid>

                  {/* render Style */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete
                      {...autoProps}
                      id="Style"
                      options={optionStyle}
                      value={
                        (filterSelectedData && filterSelectedData.style) || []
                      }
                      onChange={onStyleChanged}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Style"
                          {...autoCompleteProps}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (<><InputAdornment position="start">
                              </InputAdornment>                              
                              {params.InputProps.startAdornment}</>),
                            }}  
                        />
                      )}
                    />
                  </Grid>

                  {/* render condition */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete                      
                      id="Condition"
                      {...singleSelectProps}
                      options={filterOptionsData && filterOptionsData.condition}
                      value={filterSelectedData && filterSelectedData.condition}
                      onChange={onConditionChanged}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Condition"
                          {...autoCompleteProps}
                          inputProps={{...params.inputProps,style:{fontSize:"12px",height:"unset",}}}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: <InputAdornment position="start"></InputAdornment>,
                            }}
                        />
                      )}
                    />
                  </Grid>

                  {/* render FICO */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete
                      id="fico"
                      {...singleSelectProps}
                      options={filterOptionsData && filterOptionsData.fico}
                      value={filterSelectedData && filterSelectedData.fico}
                      onChange={onFicoChanged}
                      required
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Fico"
                          required={true}
                          error={errorFico}
                          helperText={errorFico && "Please select fico"}
                          {...autoCompleteProps}
                          inputProps={{...params.inputProps,style:{fontSize:"12px",}}}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: <InputAdornment position="start"></InputAdornment>,
                            }}
                        />
                      )}
                    />
                  </Grid>

                  {/* render Income */}
                  <Grid item xs={gridRowSize}>
                    <Autocomplete
                      id="income"
                      {...singleSelectProps}
                      options={filterOptionsData && filterOptionsData.income}
                      value={filterSelectedData && filterSelectedData.income}
                      onChange={onIncomeChanged}
                      required                                                                 
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Income"
                          required={true}
                          error={errorIncome}
                          helperText={errorIncome && "Please select income"}
                          {...autoCompleteProps}  
                          inputProps={{...params.inputProps,style:{fontSize:"12px",}}} 
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}                      
                        />
                      )}
                    />
                  </Grid>

                  {/* render year Old*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="yearOld"
                      name="yearOld"
                      label="Year Oldest"
                      InputProps={{
                        startAdornment: <InputAdornment position="start"></InputAdornment>,
                        }}
                      //error
                      //helperText="Incorrect entry."
                      //color = "primary" //focused
                      value={
                        filterSelectedData && filterSelectedData.yearOldest
                      }
                      onChange={onYearOldChanged}
                      required={false}
                      error={errorYearOld}
                      helperText={errorYearOld && "Year Old is invalid"}
                      {...textBoxProps}
                    />
                  </Grid>

                  {/* render Mile Cap*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="mileCap"
                      name="mileCap"
                      label="Mile Cap"
                      //variant = "filled"
                      InputProps={{
                      startAdornment: <InputAdornment position="start"></InputAdornment>,
                      }}
                      value={filterSelectedData && filterSelectedData.mileCap}
                      onChange={onMileCapChanged}
                      required={false}
                      error={errorMileCap}
                      helperText={errorMileCap && "Mile Cap is invalid"}
                      {...textBoxProps}
                    />
                  </Grid>

                  {/* render Financed Cap*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="finCap"
                      name="finCap"
                      label="Financed Cap"
                      InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      }}
                      value={
                        filterSelectedData && filterSelectedData.financedCap
                      }
                      onChange={onFinanceCapChanged}
                      required={false}
                      error={errorFinCap}
                      helperText={errorFinCap && "Financed Cap is invalid"}
                      {...textBoxProps}
                    />
                  </Grid>

                  {/* render Pay Cap*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="payCap"
                      name="payCap"
                      label="Pay Cap"
                      InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      }}
                      value={filterSelectedData && filterSelectedData.payCap}
                      onChange={onPayCapChanged}
                      required={false}
                      error={errorPayCap}
                      helperText={errorPayCap && "Pay Cap is invalid"}
                      {...textBoxProps}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {/* render box as user input start */}
            <Grid item xs={12}>
              <Box component="fieldset" border="none"> 
              {/* component="fieldset"  sx={InputBox}
                <legend style={props.lightMode ? legendLight : legendDark}>
                  Inputs
                </legend> */}
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {/* render Cash Down*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="cashDown"
                      name="cashDown"
                      label="Cash Down"
                      InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      }}
                      value={filterSelectedData && filterSelectedData.cashDown}
                      onChange={onCashDownChanged}
                      required={true}
                      error={errorCashDown}
                      helperText={errorCashDown && "Cash down is either empty/invalid"}
                      {...textBoxProps}
                    />
                  </Grid>

                  {/* render Trade Amt*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="tradeAmt"
                      name="tradeAmt"
                      label="Trade Amt"
                      InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      }}
                      value={filterSelectedData && filterSelectedData.tradeAmt}
                      onChange={onTradeAmtChanged}
                      required={false}
                      error={errorTradeAmt}
                      helperText={errorTradeAmt && 'Trade amt is invalid'}
                      {...textBoxProps}
                    />
                  </Grid>

                  {/* render Paid Off Amt*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="paidOffAmt"
                      name="paidOffAmt"
                      label="Paid Off Amt"
                      InputProps = {{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      }}
                      value={
                        filterSelectedData && filterSelectedData.paidOffAmt
                      }
                      onChange={onPaidOffAmtChanged}
                      required={false}
                      error={errorPaidOff}
                      helperText={errorPaidOff && 'Paid off amt is invalid'}
                      {...textBoxProps}
                    />
                  </Grid>

                  {/* render Zip Code*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="zipCode"
                      name="zipCode"
                      label="Zip Code"
                      InputProps={{
                        startAdornment: <InputAdornment position="start"></InputAdornment>,                        
                      }}
                      value={filterSelectedData && filterSelectedData.zipCode}
                      onChange={onZipCodeChanged}
                      required={true}
                      error={errorZipCode}
                      helperText={
                        errorZipCode && "Zip code either empty/invalid"
                      }
                      {...textBoxPropsFloat}
                    />
                  </Grid>

                  {/* render State Tx*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="stateTx"
                      name="stateTx"
                      label="Est State Tax"
                      value={filterSelectedData && filterSelectedData.stateTax}
                      onChange={onStateTaxChanged}
                      required={true}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                        }} 
                      error={errorStateTx}
                      helperText={
                        errorStateTx &&
                        "State tax is either empty/invalid"
                      }
                      {...textBoxPropsFloat}
                    />
                  </Grid>

                  {/* render DMV Fee*/}
                  <Grid item xs={gridRowSize}>
                    <TextField
                      id="dmvFee"
                      name="dmvFee"
                      label="Est DMV Fee" 
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}                     
                      value={filterSelectedData && filterSelectedData.dmvFee}
                      onChange={onDmvFeeChanged}
                      required={true}
                      error={errorDMV}
                      helperText={errorDMV && "DMV fee is either empty/invalid"}
                      {...textBoxProps}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {/*<Grid item xs="12" marginTop = "1.5rem" marginBottom = "1.5rem">
              <Divider
                style={props.lightMode ? SeparatorLight : SeparatorDark}
              />
            </Grid>*/}

            {/* render Apply Clear button style = {{borderRadius:"50%"}}  */}
            <Grid
              item
              xs={12}
              marginTop="1rem"
              display="flex"
              justifyContent="space-evenly"
            >
              <Button
                variant="contained"
                onClick={onApply}
                style={{ backgroundColor: "#1451B5", color: "#fff" }}
              >
                Apply
              </Button>
              <Button
                variant="contained"
                style={{ background: "#E5E7E9", color: "black" }}
                onClick={onReset}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );

  return retFilterComp;
}

const mstp = (state) => {
  return {
    user: state.user,
    metaData: state.metaData,
    selectedMetaData: state.selectedMetaData,
    filterData: state.filterData,
  };
};

export default connect(mstp, {
  setFilterOptionsAction,
  filterOptionsSelectedAction,
  filterDataAction,
})(Filters);
